import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SearchResult } from './search-result/search-result.component';

const routes: Routes = [
  {
    path: 'resultado',
    component: SearchResult,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class SharedRoutingModule {}
